var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFocusTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1006_395551",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3999 1H3.3999L5.3999 5.5L3.3999 10H9.3999L7.3999 5.5L9.3999 1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.3999 1V0.3H2.32277L2.76023 1.2843L3.3999 1ZM9.3999 1L10.0396 1.2843L10.477 0.3H9.3999V1ZM5.3999 5.5L6.03957 5.7843L6.16592 5.5L6.03957 5.2157L5.3999 5.5ZM3.3999 10L2.76023 9.7157L2.32277 10.7H3.3999V10ZM9.3999 10V10.7H10.477L10.0396 9.7157L9.3999 10ZM7.3999 5.5L6.76023 5.2157L6.63388 5.5L6.76023 5.7843L7.3999 5.5ZM3.3999 1.7H9.3999V0.3H3.3999V1.7ZM6.03957 5.2157L4.03957 0.715703L2.76023 1.2843L4.76023 5.7843L6.03957 5.2157ZM4.76023 5.2157L2.76023 9.7157L4.03957 10.2843L6.03957 5.7843L4.76023 5.2157ZM3.3999 10.7H9.3999V9.3H3.3999V10.7ZM10.0396 9.7157L8.03957 5.2157L6.76023 5.7843L8.76023 10.2843L10.0396 9.7157ZM8.76023 0.715703L6.76023 5.2157L8.03957 5.7843L10.0396 1.2843L8.76023 0.715703Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1006_395551)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8999 1H9.8999",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8999 10H9.8999",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 2.5H5.3999L6.3999 5L7.3999 2.5Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusTimer);
export default __webpack_public_path__ + "static/media/focus-timer.064c2fae.svg";
export { ForwardRef as ReactComponent };